// extracted by mini-css-extract-plugin
module.exports = {"Modal":"_2PoChSrZ9HWDW-qW6EoyA7","Open":"_2vg_ugK5Ix-C_ubAp45iiV","animate":"_1ePTcm9ZPY7cH9ql-GsOtz","Close":"_2JH_nizZ0wGLLK2TcxWfvU"};